import { IconOptions } from "./iconOptions";
export const getIcon = (glyph) => {
    const iconType = IconOptions[glyph].type === "pro" ? "glyphicon-pro" : "glyphicon";
    const iconValue = IconOptions[glyph].value;
    return { iconType, iconValue };
};
export const setIcon = (glyph) => typeof glyph == "undefined"
    ? { iconType: undefined, iconValue: undefined }
    : getIcon(glyph);
export const getIconKeys = () => {
    let icons = [];
    Object.keys(IconOptions).forEach((key) => {
        icons = [...icons, key];
    });
    return icons;
};
